import PropTypes from "prop-types";
import "./LoadingSpinner.css";

/**
 * LoadingSpinner component - Reusable loading spinner
 * Can be used as fullscreen or inline loader
 */
const LoadingSpinner = ({ fullscreen = false, message = "Loading..." }) => {
  if (fullscreen) {
    return (
      <div className="loading-spinner-overlay" role="status" aria-live="polite">
        <div className="loading-spinner-content">
          <div className="loading-spinner" aria-hidden="true"></div>
          <span className="loading-spinner-message">{message}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="loading-spinner-inline" role="status" aria-live="polite">
      <div className="loading-spinner" aria-hidden="true"></div>
      <span className="loading-spinner-message">{message}</span>
    </div>
  );
};

LoadingSpinner.propTypes = {
  fullscreen: PropTypes.bool,
  message: PropTypes.string,
};

export default LoadingSpinner;
